var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

(function() {
  var PRODUCT_COPY = {
    "gorilla-plus-customiser": {
      badge: "Most Popular",
      summary: "A bigger backyard setup with room for climbing, swinging, and future customisation."
    },
    "cheeky-little-monkey-plus-customiser": {
      badge: "Compact Pick",
      summary: "A compact plus setup for smaller yards without losing variety."
    },
    "orangutan-plus-combat-ladder-customiser": {
      summary: "A climbing-focused setup for adventurous kids and active families."
    },
    "troop-plus-flying-fox-monkey-bars-customiser": {
      badge: "Flying Fox",
      summary: "A long-run setup built around speed, movement, and big-yard play."
    },
    "mandrill-plus-customiser": {
      badge: "Big Backyard",
      summary: "A premium large-yard build for maximum climbing and swinging options."
    },
    "orangutan-plus-customiser": {
      summary: "A climbing-focused plus setup with plenty of room to customise."
    },
    "the-orangutan-customised": {
      summary: "A strong all-round frame for climbing, swinging, and backyard play."
    },
    "cheeky-little-monkey-builder": {
      summary: "A compact frame for tighter yards and everyday active play."
    },
    "gorilla-customiser-beta": {
      summary: "A family-sized frame with room for classic monkey bar play."
    },
    "gorilla-plus-combat-customiser": {
      summary: "A bigger Gorilla setup with added climbing and challenge options."
    },
    "troop-monkey-bars-customiser": {
      summary: "A wide frame made for active families and bigger backyard layouts."
    },
    "mandrill-customiser": {
      summary: "A large, high-capacity frame built for serious backyard play."
    }
  };

  var DEFAULT_SUMMARY = "Customise the frame, colours, and accessories to suit your backyard.";
  var RANGE_FALLBACKS = [
    { pattern: /cheeky little monkey/i, name: "Cheeky Little Monkey" },
    { pattern: /gorilla/i, name: "Gorilla" },
    { pattern: /orangutan/i, name: "Orangutan" },
    { pattern: /troop/i, name: "Troop" },
    { pattern: /mandrill/i, name: "Mandrill" }
  ];
  var PRODUCT_HTML_CACHE = {};
  var TARGET_COLLECTION_HANDLE = "monkey-bars";
  var ACCESSORY_COLLECTION_HANDLES = ["monkey-bar-accessories"];

  function getCollectionHandle() {
    var pathMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    if (pathMatch && pathMatch[1]) return pathMatch[1].toLowerCase();

    var canonical = document.querySelector('link[rel="canonical"]');
    var canonicalHref = canonical ? canonical.getAttribute("href") || "" : "";
    var canonicalMatch = canonicalHref.match(/\/collections\/([^/?#]+)/);

    return canonicalMatch && canonicalMatch[1] ? canonicalMatch[1].toLowerCase() : "";
  }

  function shouldEnhanceCatalogue() {
    return getCollectionHandle() === TARGET_COLLECTION_HANDLE;
  }

  function shouldUseAccessoryGrid() {
    return ACCESSORY_COLLECTION_HANDLES.indexOf(getCollectionHandle()) !== -1;
  }

  function markCatalogueRevampEnabled() {
    document.documentElement.classList.add("catalogue-revamp-enabled");

    if (document.body) {
      document.body.classList.add("catalogue-revamp-enabled");
      document.body.classList.add("collection-monkey-bars");
    }
  }

  function markAccessoryGridEnabled() {
    document.documentElement.classList.add("accessory-grid-enabled");

    if (document.body) {
      document.body.classList.add("accessory-grid-enabled");
      document.body.classList.add("collection-monkey-bar-accessories");
    }
  }

  function markCollectionLayoutClasses() {
    if (shouldEnhanceCatalogue()) markCatalogueRevampEnabled();
    if (shouldUseAccessoryGrid()) markAccessoryGridEnabled();
  }

  function getSizedImageUrl(template, width) {
    return String(template || "")
      .replace(/\{width\}/g, width)
      .replace(/^\/\//, window.location.protocol + "//");
  }

  function buildAccessorySrcset(template) {
    var widths = [360, 540, 720, 900, 1080];
    return widths.map(function(width) {
      return getSizedImageUrl(template, width) + " " + width + "w";
    }).join(", ");
  }

  function loadAccessoryGridImages() {
    if (!shouldUseAccessoryGrid()) return;

    document.querySelectorAll("#gf-products .grid-product img").forEach(function(img) {
      var dataSrc = img.getAttribute("data-src");
      var dataSrcset = img.getAttribute("data-srcset");
      var currentSrcset = img.getAttribute("srcset") || "";

      if (dataSrc) {
        img.setAttribute("src", getSizedImageUrl(dataSrc, 720));
        img.setAttribute("srcset", buildAccessorySrcset(dataSrc));
      } else if (dataSrcset && (!currentSrcset || currentSrcset.indexOf("data:image") === 0)) {
        img.setAttribute("srcset", dataSrcset);
      }

      img.setAttribute("sizes", "(min-width: 1025px) 33vw, 50vw");
      img.classList.remove("gflazyload", "gflazyloading", "lazyload", "lazyloading");
      img.classList.add("gfLazyautosizes", "lazyloaded");
      img.style.opacity = "1";
    });
  }

  function scheduleAccessoryGridImages() {
    if (!shouldUseAccessoryGrid()) return;

    loadAccessoryGridImages();
    setTimeout(loadAccessoryGridImages, 250);
    setTimeout(loadAccessoryGridImages, 1000);
  }

  markCollectionLayoutClasses();
  scheduleAccessoryGridImages();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", markCollectionLayoutClasses);
    document.addEventListener("DOMContentLoaded", scheduleAccessoryGridImages);
  }

  window.addEventListener("load", markCollectionLayoutClasses);
  window.addEventListener("load", scheduleAccessoryGridImages);

  if (window.MutationObserver && shouldUseAccessoryGrid()) {
    new MutationObserver(scheduleAccessoryGridImages).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (!shouldEnhanceCatalogue()) return;

  function cleanText(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function cleanStatValue(text) {
    var value = cleanText(text);
    return value === "-" || value === "—" ? "" : value;
  }

  function titleCase(text) {
    return cleanText(text)
      .replace(/[-_]+/g, " ")
      .replace(/\b\w/g, function(match) {
        return match.toUpperCase();
      });
  }

  function formatRangeTitle(range) {
    var rangeName = titleCase(range);
    if (!rangeName) return "Monkey Bars";
    return /\brange$/i.test(rangeName) ? rangeName : rangeName + " Range";
  }

  function inferRangeFromTitle(title) {
    var match = RANGE_FALLBACKS.find(function(range) {
      return range.pattern.test(title);
    });

    return match ? match.name : "";
  }

  function getCatalogueRange(card, title, copy) {
    var rangeEl = card ? card.querySelector("[data-catalogue-range]") : null;
    var range = cleanText(
      (card ? card.getAttribute("data-catalogue-range") : "") ||
      (rangeEl ? rangeEl.getAttribute("data-catalogue-range") || rangeEl.textContent : "") ||
      copy.range ||
      ""
    );

    return titleCase(range || inferRangeFromTitle(title) || "Monkey Bars");
  }

  function getCatalogueBadge(card) {
    var badgeEl = card ? card.querySelector(".catalogue-card__badge, [data-catalogue-badge]") : null;

    return cleanText(
      (card ? card.getAttribute("data-catalogue-badge") : "") ||
      (badgeEl ? badgeEl.getAttribute("data-catalogue-badge") || badgeEl.textContent : "")
    );
  }

  function getLoadRating(card, copy) {
    var loadFromData = card ? card.getAttribute("data-catalogue-load-rating") || card.getAttribute("data-load-rating") : "";
    var loadFromChild = card ? card.querySelector("[data-catalogue-load-rating]") : null;

    return cleanText(
      cleanStatValue(loadFromData) ||
      (loadFromChild ? cleanStatValue(loadFromChild.textContent) : "") ||
      ""
    );
  }

  function getProductHandle(card, link) {
    if (card && card.dataset && card.dataset.productHandle) return card.dataset.productHandle;

    var href = link ? link.getAttribute("href") : "";
    var match = href && href.match(/\/products\/([^?/#]+)/);
    return match ? match[1] : "";
  }

  function getProductLines(link) {
    return String(link ? link.innerText : "")
      .split("\n")
      .map(cleanText)
      .filter(Boolean);
  }

  function getTitle(card, lines) {
    var titleEl = card.querySelector(".grid-product__title");
    return cleanText(titleEl ? titleEl.textContent : lines[0]);
  }

  function getPrice(card, lines) {
    var priceEl = card.querySelector(".grid-product__price");
    var price = cleanText(priceEl ? priceEl.textContent : "");
    if (price) return price.replace(".00 AUD", " AUD");

    return cleanText(lines.find(function(line) {
      return /\$|AUD|A\$/.test(line);
    }));
  }

  function normalizeCompareText(text) {
    return cleanText(text).toLowerCase();
  }

  function getFootprint(title, price, lines) {
    var titleKey = normalizeCompareText(title);
    var priceKey = normalizeCompareText(price);
    var dimensionPattern = /\d+(?:\.\d+)?\s*m?\s*x\s*\d+(?:\.\d+)?\s*m?/i;
    var footprint = lines.find(function(line) {
      var key = normalizeCompareText(line);
      return key && key !== titleKey && key !== priceKey && dimensionPattern.test(line);
    });

    return cleanText(footprint || "");
  }

  function createStat(label, value) {
    var stat = document.createElement("div");
    stat.className = "catalogue-card__stat";

    var statLabel = document.createElement("span");
    statLabel.className = "catalogue-card__stat-label";
    statLabel.textContent = label;

    var statValue = document.createElement("span");
    statValue.className = "catalogue-card__stat-value";
    statValue.textContent = value || "-";

    stat.appendChild(statLabel);
    stat.appendChild(statValue);

    return stat;
  }

  function getAdjustableHeight(card, copy) {
    var heightFromData = card ? card.getAttribute("data-adjustable-height") : "";
    var heightFromChild = card ? card.querySelector("[data-catalogue-adjustable-height]") : null;

    return cleanText(
      cleanStatValue(heightFromData) ||
      (heightFromChild ? cleanStatValue(heightFromChild.textContent) : "") ||
      copy.adjustableHeight ||
      copy.height ||
      ""
    );
  }

  function findProductStatValue(doc, labelPattern, directSelector) {
    var directValue = doc.querySelector(directSelector);
    if (directValue) return cleanStatValue(directValue.textContent);

    var statCards = Array.prototype.slice.call(doc.querySelectorAll(".product-stat-card"));
    var statCard = statCards.find(function(card) {
      var label = cleanText(card.querySelector(".product-stat-label") ? card.querySelector(".product-stat-label").textContent : "");
      return labelPattern.test(label);
    });

    if (!statCard) return "";

    return cleanStatValue(statCard.querySelector(".product-stat-value") ? statCard.querySelector(".product-stat-value").textContent : "");
  }

  function parseProductStatsFromProductHtml(html) {
    if (!html || !window.DOMParser) return {};

    var doc = new DOMParser().parseFromString(html, "text/html");

    return {
      load: findProductStatValue(
        doc,
        /load/i,
        "[data-catalogue-load-rating], #cpb-metafield-box-source .product-stat-card--load .product-stat-value, .product-stat-card--load .product-stat-value"
      ),
      adjustableHeight: findProductStatValue(
        doc,
        /height/i,
        "[data-catalogue-adjustable-height], #cpb-metafield-box-source .product-stat-card--height .product-stat-value, .product-stat-card--height .product-stat-value"
      )
    };
  }

  function parseAdjustableHeightFromProductHtml(html) {
    return parseProductStatsFromProductHtml(html).adjustableHeight || "";
  }

  function getProductStats(url) {
    if (!url || !window.fetch) return Promise.resolve({});

    if (!PRODUCT_HTML_CACHE[url]) {
      PRODUCT_HTML_CACHE[url] = fetch(url, { credentials: "same-origin" })
        .then(function(response) {
          return response.ok ? response.text() : "";
        })
        .then(parseProductStatsFromProductHtml)
        .catch(function() {
          return {};
        });
    }

    return PRODUCT_HTML_CACHE[url];
  }

  function getProductAdjustableHeight(url) {
    return getProductStats(url).then(function(stats) {
      return stats.adjustableHeight || "";
    });
  }

  function getProductLoadRating(url) {
    return getProductStats(url).then(function(stats) {
      return stats.load || "";
    });
  }

  function hydrateAdjustableHeight(link, valueEl) {
    if (!link || !valueEl || cleanStatValue(valueEl.textContent)) return;

    getProductAdjustableHeight(link.href).then(function(adjustableHeight) {
      if (adjustableHeight) valueEl.textContent = adjustableHeight;
    });
  }

  function setLoadRatingValue(valueEl, loadRating) {
    var value = cleanStatValue(loadRating);
    if (!valueEl || !value) return;

    valueEl.textContent = value;

    var card = valueEl.closest ? valueEl.closest(".catalogue-product-card") : null;
    if (card) card.setAttribute("data-catalogue-load-rating", value);
  }

  function hydrateLoadRating(link, valueEl) {
    if (!link || !valueEl) return;

    getProductLoadRating(link.href).then(function(loadRating) {
      setLoadRatingValue(valueEl, loadRating);
    });
  }

  function getPrimaryImage(card) {
    return card.querySelector(".grid-product__image-mask img, .grid__image-ratio img, img");
  }

  function isPlaceholderImage(value) {
    return !value || /^data:image\/gif/i.test(value);
  }

  function normalizeImageUrl(value) {
    if (!value) return "";
    if (value.indexOf("//") === 0) return window.location.protocol + value;
    return value;
  }

  function imageUrlFromTemplate(value, width) {
    var imageWidth = width || "700";
    var imageUrl = String(value || "").replace("{width}", imageWidth);
    return imageUrl.replace(/([?&]width=)\d+/i, "$1" + imageWidth);
  }

  function firstSrcsetUrl(value) {
    if (!value) return "";
    return value.split(",")[0].trim().split(/\s+/)[0];
  }

  function getBestImageUrl(image) {
    if (!image) return "";

    var dataSrc = image.getAttribute("data-src");
    if (dataSrc) return normalizeImageUrl(imageUrlFromTemplate(dataSrc, "700"));

    var dataSrcset = image.getAttribute("data-srcset");
    if (dataSrcset) return normalizeImageUrl(imageUrlFromTemplate(firstSrcsetUrl(dataSrcset), "700"));

    var src = image.getAttribute("src");
    if (src && !isPlaceholderImage(src)) return normalizeImageUrl(src);

    var currentSrc = image.currentSrc;
    if (currentSrc && !isPlaceholderImage(currentSrc)) return normalizeImageUrl(currentSrc);

    var srcset = image.getAttribute("srcset");
    if (srcset && !isPlaceholderImage(srcset)) return normalizeImageUrl(firstSrcsetUrl(srcset));

    return "";
  }

  function prepareImage(image) {
    var bestImageUrl = getBestImageUrl(image);

    image.className = "catalogue-card__image";
    image.removeAttribute("style");
    image.removeAttribute("srcset");
    image.removeAttribute("data-srcset");
    image.removeAttribute("sizes");
    image.removeAttribute("data-sizes");
    image.setAttribute("loading", "lazy");
    image.setAttribute("decoding", "async");

    if (bestImageUrl) image.setAttribute("src", bestImageUrl);
  }

  function formatCataloguePrice(price) {
    var priceText = cleanText(price).replace(/\s*AUD$/i, "");
    if (!priceText) return "";
    if (/^A\$/i.test(priceText)) return priceText.replace(/^A\$/i, "$");
    if (priceText.indexOf("$") !== -1) return priceText;
    return "$" + priceText;
  }

  function createFooterPrice(price) {
    var amount = formatCataloguePrice(price);
    var priceEl = document.createElement("span");
    priceEl.className = "catalogue-card__price";

    var label = document.createElement("span");
    label.className = "catalogue-card__price-label";
    label.textContent = "From";

    var value = document.createElement("span");
    value.className = "catalogue-card__price-value";
    value.textContent = amount;

    priceEl.appendChild(label);
    priceEl.appendChild(document.createTextNode(" "));
    priceEl.appendChild(value);

    return priceEl;
  }

  function enhanceCard(card) {
    if (!card || card.classList.contains("catalogue-product-card")) return;

    var existingLink = card.querySelector("a.grid-product__link");
    if (!existingLink) return;

    var lines = getProductLines(existingLink);
    var title = getTitle(card, lines);
    var price = getPrice(card, lines);
    var footprint = getFootprint(title, price, lines);
    var handle = getProductHandle(card, existingLink);
    var copy = PRODUCT_COPY[handle] || {};
    var catalogueRange = getCatalogueRange(card, title, copy);
    var catalogueBadge = getCatalogueBadge(card);
    var loadRating = getLoadRating(card, copy);
    var adjustableHeight = getAdjustableHeight(card, copy);
    var image = getPrimaryImage(card);

    card.classList.add("catalogue-product-card");
    card.classList.remove("medium-up--one-quarter");
    card.classList.add("medium-up--one-third");
    card.setAttribute("data-catalogue-range", catalogueRange);
    if (catalogueBadge) card.setAttribute("data-catalogue-badge", catalogueBadge);
    if (loadRating) card.setAttribute("data-catalogue-load-rating", loadRating);

    existingLink.className = "catalogue-card";
    existingLink.setAttribute("data-catalogue-range", catalogueRange);
    existingLink.textContent = "";

    var media = document.createElement("div");
    media.className = "catalogue-card__media";

    if (catalogueBadge) {
      var badge = document.createElement("span");
      badge.className = "catalogue-card__badge";
      badge.textContent = catalogueBadge;
      media.appendChild(badge);
    }

    if (image) {
      prepareImage(image);
      media.appendChild(image);
    }

    var body = document.createElement("div");
    body.className = "catalogue-card__body";

    var heading = document.createElement("h3");
    heading.className = "catalogue-card__title";
    heading.textContent = title;

    var summary = document.createElement("p");
    summary.className = "catalogue-card__summary";
    summary.textContent = copy.summary || DEFAULT_SUMMARY;

    var stats = document.createElement("div");
    stats.className = "catalogue-card__stats";
    stats.setAttribute("aria-label", title + " specifications");
    stats.appendChild(createStat("Footprint", footprint));
    var loadStat = createStat("Load Rating", loadRating);
    var loadValue = loadStat.querySelector(".catalogue-card__stat-value");
    loadValue.setAttribute("data-catalogue-load-rating", "");
    stats.appendChild(loadStat);
    hydrateLoadRating(existingLink, loadValue);
    var heightStat = createStat("Adjustable Height", adjustableHeight);
    var heightValue = heightStat.querySelector(".catalogue-card__stat-value");
    heightValue.setAttribute("data-catalogue-adjustable-height", "");
    stats.appendChild(heightStat);
    hydrateAdjustableHeight(existingLink, heightValue);

    var footer = document.createElement("div");
    footer.className = "catalogue-card__footer";

    var button = document.createElement("span");
    button.className = "catalogue-card__button";
    button.textContent = "View & Customise";

    footer.appendChild(createFooterPrice(price));
    footer.appendChild(button);

    body.appendChild(heading);
    body.appendChild(summary);
    body.appendChild(stats);
    body.appendChild(footer);

    existingLink.appendChild(media);
    existingLink.appendChild(body);
  }

  function upgradeEnhancedCard(card) {
    if (!card || !card.classList.contains("catalogue-product-card")) return;

    var link = card.querySelector(".catalogue-card");
    var titleEl = card.querySelector(".catalogue-card__title");
    var title = cleanText(titleEl ? titleEl.textContent : "");
    var range = getCatalogueRange(card, title, {});
    var badge = getCatalogueBadge(card);
    var priceValue = card.querySelector(".catalogue-card__price-value");
    var loadValue = findCardStatValueEl(card, /load/i);
    var heightValue = findCardStatValueEl(card, /height/i);

    card.setAttribute("data-catalogue-range", range);
    if (badge) card.setAttribute("data-catalogue-badge", badge);
    if (link) link.setAttribute("data-catalogue-range", range);
    if (priceValue) priceValue.textContent = formatCataloguePrice(priceValue.textContent);
    if (loadValue) {
      var loadStatEl = loadValue.closest ? loadValue.closest(".catalogue-card__stat") : null;
      var loadLabel = loadStatEl ? loadStatEl.querySelector(".catalogue-card__stat-label") : null;
      if (loadLabel) loadLabel.textContent = "Load Rating";
      loadValue.setAttribute("data-catalogue-load-rating", "");
      hydrateLoadRating(link, loadValue);
    }
    if (heightValue) {
      heightValue.setAttribute("data-catalogue-adjustable-height", "");
      hydrateAdjustableHeight(link, heightValue);
    }
  }

  function findCardStatValueEl(card, labelPattern) {
    var stats = Array.prototype.slice.call(card ? card.querySelectorAll(".catalogue-card__stat") : []);
    var stat = stats.find(function(item) {
      var label = cleanText(item.querySelector(".catalogue-card__stat-label") ? item.querySelector(".catalogue-card__stat-label").textContent : "");
      return labelPattern.test(label);
    });

    return stat ? stat.querySelector(".catalogue-card__stat-value") : null;
  }

  function getDirectCatalogueCards(container) {
    return Array.prototype.slice.call(container ? container.children : []).filter(function(child) {
      return child.classList && child.classList.contains("catalogue-product-card");
    });
  }

  function createRangePanel(range) {
    var panel = document.createElement("section");
    panel.className = "catalogue-range-panel";
    panel.setAttribute("data-catalogue-range-panel", range);

    var header = document.createElement("div");
    header.className = "catalogue-range-panel__header";

    var title = document.createElement("h2");
    title.className = "catalogue-range-panel__title";
    title.textContent = formatRangeTitle(range);

    var controls = document.createElement("div");
    controls.className = "catalogue-range-panel__controls";

    var prev = document.createElement("button");
    prev.className = "catalogue-range-panel__arrow catalogue-range-panel__arrow--prev";
    prev.type = "button";
    prev.setAttribute("aria-label", "Previous " + formatRangeTitle(range));
    prev.textContent = "<";

    var next = document.createElement("button");
    next.className = "catalogue-range-panel__arrow catalogue-range-panel__arrow--next";
    next.type = "button";
    next.setAttribute("aria-label", "Next " + formatRangeTitle(range));
    next.textContent = ">";

    controls.appendChild(prev);
    controls.appendChild(next);
    header.appendChild(title);
    header.appendChild(controls);

    var track = document.createElement("div");
    track.className = "catalogue-range-panel__track";
    track.setAttribute("tabindex", "0");
    track.setAttribute("aria-label", formatRangeTitle(range) + " products");

    panel.appendChild(header);
    panel.appendChild(track);

    return panel;
  }

  function scrollRangeTrack(track, direction) {
    if (!track) return;

    var firstCard = track.querySelector(".catalogue-product-card");
    var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth;
    var amount = Math.max(cardWidth, track.clientWidth * 0.8) * direction;

    if (track.scrollBy) {
      track.scrollBy({ left: amount, behavior: "smooth" });
    } else {
      track.scrollLeft += amount;
    }
  }

  function initRangeCarousel(panel) {
    if (!panel || panel.getAttribute("data-catalogue-carousel-ready") === "true") return;

    var track = panel.querySelector(".catalogue-range-panel__track");
    var prev = panel.querySelector(".catalogue-range-panel__arrow--prev");
    var next = panel.querySelector(".catalogue-range-panel__arrow--next");

    if (prev) {
      prev.addEventListener("click", function(event) {
        event.preventDefault();
        scrollRangeTrack(track, -1);
      });
    }

    if (next) {
      next.addEventListener("click", function(event) {
        event.preventDefault();
        scrollRangeTrack(track, 1);
      });
    }

    panel.setAttribute("data-catalogue-carousel-ready", "true");
  }

  function findExistingRangePanel(container, range) {
    var panels = Array.prototype.slice.call(container.querySelectorAll(".catalogue-range-panel"));
    return panels.find(function(panel) {
      return panel.getAttribute("data-catalogue-range-panel") === range;
    });
  }

  function buildRangeCarousels(container) {
    var directCards = getDirectCatalogueCards(container);
    if (!container || !directCards.length) return;

    container.classList.add("catalogue-range-grid");

    directCards.forEach(function(card) {
      var link = card.querySelector(".catalogue-card");
      var title = cleanText(card.querySelector(".catalogue-card__title") ? card.querySelector(".catalogue-card__title").textContent : "");
      var range = getCatalogueRange(card, title, {});
      var panel = findExistingRangePanel(container, range);

      if (!panel) {
        panel = createRangePanel(range);
        container.appendChild(panel);
      }

      card.setAttribute("data-catalogue-range", range);
      if (link) link.setAttribute("data-catalogue-range", range);

      panel.querySelector(".catalogue-range-panel__track").appendChild(card);
      initRangeCarousel(panel);
    });
  }

  function enhanceCollectionCards() {
    if (!shouldEnhanceCatalogue()) return;
    markCatalogueRevampEnabled();

    var container = document.querySelector("#gf-products");
    document.querySelectorAll("#gf-products .grid-product").forEach(enhanceCard);
    document.querySelectorAll("#gf-products .catalogue-product-card").forEach(upgradeEnhancedCard);
    buildRangeCarousels(container);
  }

  function scheduleEnhance() {
    window.clearTimeout(scheduleEnhance.timer);
    scheduleEnhance.timer = window.setTimeout(enhanceCollectionCards, 80);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceCollectionCards);
  } else {
    enhanceCollectionCards();
  }

  window.addEventListener("load", enhanceCollectionCards);
  window.setTimeout(enhanceCollectionCards, 500);
  window.setTimeout(enhanceCollectionCards, 1500);

  if (window.MutationObserver) {
    new MutationObserver(scheduleEnhance).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();